import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle, defaultContext, getFocusedStyle, getUnFocusedStyle } from './blockHeader.style';
import { getTitle } from '../../../blocks/utils/block';

export class BlockHeader extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Label: {},
        Line: {
          rect: true,
        },
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._isFocused = false;
    this._isSelected = false;
  }

  _attach() {
    const label = this.tag('Label');
    label.on('txLoaded', () => {
      this.w = label.finalW;
    });
  }

  _detach() {
    this.tag('Label').removeAllListeners('txLoaded');
    this._item = undefined;
  }

  get item() {
    return this._item;
  }

  set item(value) {
    const { title } = value;
    this._item = value;
    this.tag('Label').text = {
      text: typeof title === 'string' ? title : getTitle(title),
    };
  }

  get isSelected() {
    return this._isSelected;
  }

  set isSelected(value) {
    this._isSelected = value;
    this._updateStyle();
  }

  _updateStyle() {
    this.patch(this._isFocused ? getFocusedStyle(this._isSelected) : getUnFocusedStyle(this._isSelected));
  }

  _focus() {
    this._isFocused = true;
    this._updateStyle();
  }

  _unfocus() {
    this._isFocused = false;
    this._updateStyle();
  }
}
